// extracted by mini-css-extract-plugin
export var icon = "_7g-1";
export var subtext = "_7g-0";